export default {

    Account: {

        Login: "/Account/Login",
        Register: "/Account/Register",
        ForgotPassword: "/Account/Forgot/Password",
        ResetPassword: "/Account/NewPassword"        
    },

    Client: {

        Feed: "/",

        About: {
            Index: "/About"
        },

        Audit: {
            Index: "/Audit",
            Add: "/Audit/Add"
        },

        Form: {
            Index: "/Form",
            Answer: "/Form/Answer",
            CreateTask: "/Form/CreateTask"
        },

        Help: {
            Index: "/Help"
        },

        Gallery: {
            Index: "/Gallery",
            Edit: "/Gallery/Edit"
        },

        TradePoints: {
            Index: "/TradePoints",
            Edit: "/TradePoint/Edit",
            View: "/TradePoint/View"
        },

        Settings: {
            Index: "/Settings"
        }

    },

    Admin: {

        Audits: {
            Index: "/Admin/Audits"
        },

        FutureAudits: {
            Index: "/Admin/FutureAudits"
        },

        Routes: {
            Index: "/Admin/Routes"
        },

        Users: {
            Index: "/Admin/Users",
            Edit: "/Admin/Users/Edit"
        },

        Activities: {
            Index: "/Admin/Activities",
            Edit: "/Admin/Activities/Edit"
        },

        Blocks: {
            Index: "/Admin/Blocks",
            Edit: "/Admin/Blocks/Edit"
        },

        Branches: {
            Index: "/Admin/Branches"
        },

        Questions: {
            Index: "/Admin/Questions",
            Edit: "/Admin/Questions/Edit"
        },

        Tma: {
            Index: "/Admin/Tma"
        },

        TodoCategories: {
            Index: "/Admin/TodoCategories",
            Edit: "/Admin/TodoCategories/Edit"
        },

        StandardBooks: {
            Index: "/Admin/StandardBooks",
            Edit: "/Admin/StandardBooks/Edit"
        },

        MobileVersions: {
            Index: "/Admin/MobileVersions"
        },

        MmlCategories: {
            Index: "/Admin/MmlCategories",
            Edit: "/Admin/MmlCategories/Edit"
        },
        
        PhotoCategories: {
            Index: "/Admin/PhotoCategories",
            Edit: "/Admin/PhotoCategories/Edit"
        },

        Tags: {
            StandardsBook: {
                Index: "/Admin/Tags/StandardsBook",
                Edit: "/Admin/Tags/StandardsBook/Edit",
            },
            Activities: {
                Index: "/Admin/Tags/Activities",
                Edit: "/Admin/Tags/Activities/Edit"
            } 
        },

        Bot: {
            Filters: {
                Index: "/Admin/Bot/Filters",
                Edit: "/Admin/Bot/Filters/Edit",
            }
        },

        Cache: {
            Index: "/Admin/Cache"
        },

        SubSections: {
            Index: "/Admin/SubSections"
        }

    }
}